<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary pos-relative {{ sectionclass }}"
	style="min-height: 23em"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet o-block u-width-100p _u-width-100p daily_metrics_stats_container">
		<div class="o-stack__cell daily_metrics_heading_r1 primary-color">
			<h5 class="title">
				{{ sectiontitle }}
				<a
					href="javascript:void(0)"
					class="download_icon daily_metrics_download_icon"
					*ngIf="downloadConfiguration?.enableDownload && hasData"
					(click)="downloadCSV()"
					target="_blank"
				>
					<i *ngIf="!downloadConfiguration?.enablePNG && !downloadIcon" class="fa fa-download" aria-hidden="true"></i>
					<img
						*ngIf="downloadConfiguration?.enablePNG && !downloadIcon"
						src="../../../../../assets/images/Download_Icon.svg"
					/>
					<img *ngIf="downloadIcon" class="downloadIcon" src="{{ downloadIcon }}" />
				</a>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content daily_metrics_custom_height cox_r5_daily_metric_styles" [ngClass]="{'no-daily-stats-data-tv': !hasData}">
		<div style="width: 100%; height: auto">
			<div class="colorBg" class="graph">
				<div class="daily_metrics_wrapper">
					<div id="graph-area" #graphArea></div>
				</div>
				<div class="daily_metrics_legend_area">
					<ul class="daily_metrics_legend">
						<li
							class="daily_metrics_legend_item primary-color-border"
							[ngClass]="{ daily_metrics_item_selected: legendItem.selected }"
							(click)="processSelectedLegendItem(legendItem)"
							*ngFor="let legendItem of legend"
						>
							<span class="daily_metrics_legend_display_name">{{ legendItem.displayName }}</span>
							<i
								*ngIf="legendItem.selected && legendItem.showArrow"
								class="fa fa-caret-left"
								[ngStyle]="{ 'font-size': '18px', color: colorPalette.primaryColor }"
							></i
							><i *ngIf="!legendItem.selected && legendItem.showArrow" class="space"></i>
							<ul *ngIf="legendItem.isStackedChart && showMetrics" class="metrics" (click)="$event.stopPropagation()">
								<li *ngFor="let metric of legendItem.metrics; let i = index" class="sub-li">
									<span *ngIf="metric.enabled">
										<div
											class="left-circle"
											[ngClass]="{ 'highlight-dark': i === selectedBar }"
											[id]="'tooltipid' + i"
											[ngStyle]="{ background: getColors(i, metric) }"
											tooltip="<p><b>{{ metric.displayName }}</b></p><p>{{ metric.dayparttime }}</p>"
											[options]="tooltipOptions"
										></div>
										<span (mouseenter)="toggleTooltip('tooltipid' + i)" (mouseleave)="toggleTooltip('tooltipid' + i)"
											>{{ metric.displayName }}
										</span>
									</span>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
			<div class="daily_metrics_date_div">
				{{ dateRange }}
			</div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
				<div class="o-stack__cell daily_metrics_heading_r1">
					<h5 class="title">{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data c-portlet">No Data to Display</div>
		</div>
	</div>
</div>
